

export const tableColumns = [
    // {
    //     name: 'Request ID',
    //     selector: (row, index) => index + 1,
    //     sortable: true,
    //     center: true,
    //     minWidth: '6.25rem',
    // },
    {
        name: 'Request ID',
        selector: (row, index, pageNumber, perPage) => {
            const sosId = `SOS-${row.sos_id.toString().padStart(3, '0')}`;
            return (
                <div style={{
                    color: '#5C61F2',
                    fontWeight: '500'
                }}>
                    {sosId}
                </div>
            );
        },
        sortable: true,
        center: true,
        minWidth: '6.25rem',
    },
    {
        name: (
            <div className="d-flex align-items-center gap-1">
                Request Type
                {/* <img src={UpDown} alt="sort" style={{ width: '24px', height: '24px' }} /> */}
            </div>
        ),
        selector: row => row.user_name,
        sortable: true,
        center: true,
        minWidth: '12.5rem',
    },
    {
        name: (
            <div className="d-flex align-items-center gap-1">
                First Name
                {/* <img src={UpDown} alt="sort" style={{ width: '24px', height: '24px' }} /> */}
            </div>
        ),
        selector: row => row.mobile,
        sortable: true,
        center: true,
        minWidth: '9.375rem',
    },
    {
        name: (
            <div className="d-flex align-items-center gap-1">
                Status
                {/* <img src={UpDown} alt="sort" style={{ width: '24px', height: '24px' }} /> */}
            </div>
        ),
        selector: row => row.emergency_type,
        sortable: true,
        center: true,
        minWidth: '9.375rem',
    },
    {
        name: 'Phone Number',
        selector: row => row.bloodgroup,
        sortable: true,
        center: true,
        minWidth: '6.25rem',
    },
    {
        name: 'Blood Group',
        selector: row => row.age,
        sortable: true,
        center: true,
        minWidth: '6.25rem',
    },
    {
        name: 'Action',
        selector: row => row.action,
        sortable: false,
        center: true,
        minWidth: '10rem',
    },
];